import React from 'react';
import {HashRouter} from "react-router-dom";
import './App.css';
import MyNavigationBar from "./NavBar/MyNavigationBar";
import MyRouter from "./Router/MyRouter";
import Footer from "./Page/Footer";
import UpperFooter from "./MasterPages/UpperFooter";
import ScrollToTop from "./ScrollToTop";


function App() {
    return (
        <HashRouter>
            <ScrollToTop>
                <div className="App">


                    <MyNavigationBar/>
                    <MyRouter/>
                    <UpperFooter/>
                    <Footer/>


                </div>
            </ScrollToTop>
        </HashRouter>

    );
}

export default App;

